<template>
<span class="checkbox-component-root" @click.stop="doNothing">

  <svg class="defs-only" xmlns="http://www.w3.org/2000/svg" >
    <path id="checkmark" d="m 18.71637,0.35702605 c 0.795191,0.60808739 1.029071,1.82426225 0.420984,2.66622935 L 9.454731,17.149594 C 8.8466436,17.991561 7.7240207,18.178665 6.9288295,17.570577 6.1336383,16.96249 0.520524,10.694512 0.520524,10.694512 -0.18111534,9.9460966 -0.18111534,8.7299218 0.56729995,7.9815065 1.3157152,7.2330912 2.4383381,7.2798672 3.1399774,8.0750584 L 7.7707967,13.080086 16.190469,0.77800962 c 0.608087,-0.84196716 1.73071,-1.02907098 2.525901,-0.42098357 z" />
  </svg>

  <label class="checkbox-wrapper" :class="{'checkbox-wrapper--checked': shouldBeChecked}">
    <input type="checkbox" :checked="shouldBeChecked" @change.stop.prevent="updateInput">

    <svg class="check-mark" viewBox="0 0 21 21" width="21" height="21" :style="{color: checkmarkColor}">
      <use xlink:href="#checkmark"/>
    </svg>
    <div class="check-curtain">
      <div class="shade"></div>
    </div>
    <div class="checkbox" :style=borderColor></div>
    <div class="disabled-curtain" :style=isDisabledStyle></div>
  </label>

</span>
</template>

<script>
export default {
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    modelValue: {
      default: false
    },
    trueValue: {
      default: true
    },
    falseValue: {
      default: false
    },
    disabled: {
      default: false
    },
    borderColorFalse: {
      default: '#e6e6e6'
    },
    borderColorTrue: {
      default: '#e6e6e6'
      //4af2a1
    },
    checkmarkColor: {
      devault: '#333'
    }
    // checked: {
    //   type: Boolean,
    //   default: false,
    // },
    // name: {
    //   type: String,
    // },
  },
  computed: {
    shouldBeChecked() {
      return this.modelValue === this.trueValue
    },
    borderColor() {
      let color = this.shouldBeChecked ? this.borderColorTrue : this.borderColorFalse;
      return {'border-color': color};
    },
    isDisabledStyle() {
      let displayResult = this.disabled ? 'inherit' : 'none';
      return {'display': displayResult};
    }
  },
  methods: {
    updateInput(event) {
      if (this.disabled) {
        return;
      }
      let isChecked = event.target.checked
      this.$emit('change', isChecked ? this.trueValue : this.falseValue)
    },
    doNothing() {
      // Stop clicks from bubbling
    }
  }
}
</script>

<style scoped>
.checkbox-component-root{--transition-speed: .4s;}
.defs-only {display:none;}
label {padding: 0; margin-right:6px;}
label.checkbox-wrapper {
  position: relative;
  display: inline-block;
  height: 21px;
  width: 21px;
  box-sizing: border-box;
  cursor: pointer;
  vertical-align: middle;
}

label.checkbox-wrapper input {
  display: none;
}
.check-mark {
  color: #333;
  fill: currentColor;
  position: absolute;
  top: 5px;
  left: 5px;
  width: 12px;
  height: 12px;
  z-index: 1;
}

label.checkbox-wrapper--checked.checkbox-wrapper .check-mark {
  display: inherit;
}

label.checkbox-wrapper .check-curtain {
  position: absolute;
  overflow: hidden;
  height: 18px;
  width: 18px;
  background: #fff;
  margin: 2px;
}

label.checkbox-wrapper .shade {
  height: 18px;
  width: 18px;
  background: #fff;
  z-index:5;
  position:absolute;
  transition: var(--transition-speed);
}

label.checkbox-wrapper.checkbox-wrapper--checked .shade{
    transform: translateX(25px);
}

label.checkbox-wrapper .checkbox {
  height: 20px;
  width: 20px;
  border-radius: 3px;
  box-sizing: border-box;
  border: solid 2px #e6e6e6;
  z-index:10;
  transition: var(--transition-speed);
  position:relative;
}

label.checkbox-wrapper.checkbox-wrapper--checked .checkbox {
  border: solid 2px #4af2a1;
}

.disabled-curtain {
    position: absolute;
    width: 21px;
    height: 21px;
    background: rgba(255,255,255,.6);
    top: 0;
    left: 0;
    z-index: 15;
    cursor: not-allowed;
}

/* JS Fiddle: https://jsfiddle.net/eywraw8t/520403/ */
</style>



// WEBPACK FOOTER //
// src/componentsReusable/CheckboxControl.vue